import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import heroImg from "../components/images/ranchWeddingImages/eventDeck.jpg";
import "../assets/css/packages.css";

const weddingPackages = [
  {
    name: "Elope",
    description: "Access to our 50 acre grounds and covered event deck for 4 hours.",
    note: "Monday – Thursday, or call for last minute weekend availability.",
    price: "$1,000",
    link: "Elope",
  },
  {
    name: "Epic Elope",
    description: "Access to our 50 acre grounds and covered event deck for 4 hours, plus one night accommodations for two in our penthouse suite.",
    note: "Monday – Thursday, or call for last minute weekend availability.",
    price: "$1,600",
    link: "Epic+Elope",
  },
  {
    name: "Micro Wedding",
    description: "Access to our 50 acre grounds and covered event deck for 6 hours. Tables and chairs included.",
    note: "Monday – Thursday, or call for last minute weekend availability. Guest limit: 30.",
    price: "$1,250",
    link: "Micro+Wedding",
  },
  {
    name: "The Perfect Day",
    description: "Access to our 50 acre grounds and covered event deck for 10 hours (10pm cutoff). Tables and chairs included.",
    note: "Guest limit: 200.",
    price: "$2,500",
    link: "The+Perfect+Day",
  },
  {
    name: "The Perfect Weekend",
    description: "Access to our 50 acre grounds and covered event deck for 10 hours (10pm cutoff), plus overnight accommodations. Tables and chairs included.",
    note: "Ceremony guest limit: 200. Overnight guest limit: 60.",
    price: "$5,700",
    link: "The+Perfect+Weekend",
  },
  {
    name: "The Weekend Dream",
    description: "Access to our 50 acre grounds and covered event deck for 10 hours (10pm cutoff), plus 2 nights accommodations. Tables and chairs included.",
    note: "Ceremony guest limit: 200. Overnight guest limit: 60.",
    price: "$8,900",
    link: "The+Weekend+Dream",
  },
];

const vacationRentals = [
  {
    name: "1 Lodge",
    description: "Access to the grounds and use of 1 lodge. This does not allow the property to be used as a wedding venue.",
    note: "Guest limit: 30.",
    price: "$1,600 / night",
    link: "1+Lodge",
  },
  {
    name: "2 Lodges",
    description: "Access to the grounds and both lodges. This does not allow the property to be used as a wedding venue.",
    note: "Guest limit: 60.",
    price: "$3,200 / night",
    link: "2+Lodges",
  },
];

function PackageCard({ pkg }) {
  return (
    <Col xl={4} md={6} className="d-flex">
      <div className="package-card">
        <h3 className="package-card-name">{pkg.name}</h3>
        <div className="package-card-divider"></div>
        <p className="package-card-desc">{pkg.description}</p>
        <p className="package-card-note">{pkg.note}</p>
        <p className="package-card-price">{pkg.price}</p>
        <Link to={`/contact?package=${pkg.link}`} className="package-card-btn">
          Inquire
        </Link>
      </div>
    </Col>
  );
}

export default function Pricing() {
  return (
    <>
      <div className="packages-hero">
        <img className="packages-hero-img" src={heroImg} alt="Cascade Mountain Ranch event deck" />
        <div className="packages-hero-overlay">
          <p className="packages-hero-eyebrow">Cascade Mountain Ranch</p>
          <h1>Pricing</h1>
          <p className="packages-hero-sub">Packages & Rentals</p>
        </div>
      </div>

      <div className="packages-section">
        <Container>

          <div className="packages-intro">
            <div className="packages-accent-line"></div>
            <p>
              We know that each wedding is unique. The packages below are designed to fit a variety
              of visions and budgets — and if none of them quite match yours, just give us a call.
              We are happy to work with you to create something perfect.
            </p>
          </div>

          <div className="packages-category">
            <h2 className="packages-category-title">Wedding Packages</h2>
            <div className="packages-category-line"></div>
            <Row>
              {weddingPackages.map((pkg) => (
                <PackageCard key={pkg.name} pkg={pkg} />
              ))}
            </Row>
          </div>

          <div className="packages-category">
            <h2 className="packages-category-title">Vacation Rentals</h2>
            <div className="packages-category-line"></div>
            <p className="packages-category-desc">
              In addition to our wedding packages, our venue is available for personal retreats,
              business meetings, and relaxing getaways. Whether you're planning a family vacation,
              a corporate event, or just need a serene space to unwind — our facilities can
              accommodate your needs year-round.
            </p>
            <Row>
              {vacationRentals.map((pkg) => (
                <PackageCard key={pkg.name} pkg={pkg} />
              ))}
            </Row>
          </div>

          <div className="packages-disclosures">
            <p>* In addition to the above pricing there is a refundable security and damages deposit.</p>
            <p>** Alcohol is permitted with a licensed bartender, insurance rider, and refundable security deposit.</p>
          </div>

        </Container>
      </div>
    </>
  );
}
